<script setup>
import { User } from 'lucide-vue-next'
</script>

<template>
  <User v-bind="$attrs" />
</template>
